<template lang="pug">
  .rhpa-opts(v-if="product")
    rhpa-child(v-if="isGroupedChild && groupMeta" :groupMeta="groupMeta" :layout="layout" :buyRequest="buyRequest" @status="status = $event")
    .bundle(v-if="product.type === 'bundle'" :class="[firstBundleOption ? 'bundle-has-sort' : '', isRhinoIndy ? 'grid-mode' : '']")
      bundle-option(
        v-for="(child, i) in bundleOptions"
        :key="buyRequest.productId + '' + i"
        :buyRequest="child"
        :bundleBuyRequest="buyRequest"
        :class="child.metadata.bundleOptionId === firstBundleOption ? 'first-bundle-opt' : null"
      )
    giftcard(v-if="product.type === 'giftcard'" :buyRequest="buyRequest")
    giftcard-links(
      v-if="buyRequest.isPhysicalGiftcard && ['USA', 'APO'].includes($rogue.site.code)"
    )
    configure-buy-request(:buyRequest="buyRequest" :layout="layout")
    loading.rhpa-loading(
      v-if="buyRequest.loading"
      :height="(product.type === 'grouped' || product.type === 'bundle') ? 350 : 76"
    )
    grouped-parent(
      v-else-if="product.type === 'grouped'"
      :buyRequest="buyRequest"
      :addToCartDisabled="addToCartDisabled"
    )
</template>
<script>
import { defineAsyncComponent, toRef } from 'vue'
import { useProductStore } from '@/js/stores/productStore'
import { findBundleProduct } from '@/js/pages/product/rackbuilder/utils/rackbuilder-util'
import { useMassStorage } from '@/js/composables/useMassStorage'


export default {
  name       : 'RhpaBody',
  components : {
    Giftcard      : defineAsyncComponent(() => import(/* webpackChunkName: "giftcard" */'@/js/components/rhpa/giftcard.vue')),
    GiftcardLinks : defineAsyncComponent(() => import(/* webpackChunkName: "giftcard" */'@/js/components/rhpa/giftcard-links.vue')),
    BundleOption  : defineAsyncComponent(() => import(/* webpackChunkName: "bundle-group" */'@/js/components/rhpa/bundle-option.vue')),
    RhpaChild     : defineAsyncComponent(() => import(/* webpackChunkName: "bundle-group" */'@/js/components/rhpa/rhpa-child.vue')),
    GroupedParent : defineAsyncComponent(() => import(/* webpackChunkName: "bundle-group" */'@/js/components/rhpa/grouped-parent.vue')),
  },

  props: {
    buyRequest: {
      type     : Object,
      required : true,
    },
    groupMeta: {
      type     : Object,
      required : false,
    },
    layout: {
      type    : String,
      default : 'default',
    },
    addToCartDisabled: {
      type    : Boolean,
      default : true,
    },
  },

  setup(props) {
    const productStore = useProductStore()
    const buyRequestRef = toRef(props, 'buyRequest')
    const { is3DStorageProduct } = useMassStorage(buyRequestRef)

    return { 
      productStore ,
      is3DStorageProduct,
    }
  },

  data: () => ({
    status: '',
  }),

  computed: {
    products() {
      return this.productStore.products
    },

    product() {
      return this.products[this.buyRequest.productId]
    },

    firstBundleOption() {
      if (!this.product.sku.includes('RM-RHINO-RACK-BUNDLE')) {
        return undefined
      }

      return this.product.bundleOptions?.find(opt => opt.title === 'Functional Trainer:')?.id
    },

    isGroupedChild() {
      const groupedId = this.buyRequest.metadata?.groupedProductId

      // Don't show qty stepper for mass storage unit bundles/grouped products.
      // Simple accessories (bolt kits, wheels) still need rhpa-child to render their info.
      if (this.is3DStorageProduct && (this.product?.type === 'bundle' || this.product?.type === 'grouped')) {
        return false
      }

      return groupedId && (this.products[groupedId]?.childrenIds.length !== 1 || this.products[groupedId]?.roguebuilder?.props?.showAsGrouped)
    },

    bundleOptions() {
      return this.buyRequest.children.filter(child => (child.metadata || {}).bundleOptionId)
    },

    isRhinoIndy() {    
      const rhino = findBundleProduct(this.$rogue, this.buyRequest, 'trainer')

      return rhino?.attributes.rig_type?.toString().toLowerCase().includes('indy')
    },
  },
}
</script>
<style lang="scss" scoped>

@include mobile() {
  .rhpa.grouped,
  .rhpa.type-grouped, 
  .rhpa.type-configurable {
    .rhpa-body > .rhpa-opts:first-child {
      min-height: 80px;
    }
  }
}

.grouped-rhpa, .custom-options {
  margin-top: $space-s;
}

.bundle, .design {
  margin-top: $space-s;
}

</style>
<style lang="scss">
// FTX Rhino - move the Model Type to the top
.bundle-has-sort {
  display: flex;
  flex-direction: column;

  .edit-attr {
    margin-top: 0 !important;
  }
  .bundle-opt {
    margin-bottom: 0 !important;
  }

  .first-bundle-opt {
    order: -3;
  }

  .bundle-opt:nth-child(1) {
    order: -2;
  }

  .teleport-attributes{
    order: -1;
  }

  #teleport-swatch-anchor{
    display: flex;
    flex-direction: column;
    .edition{
      order: -1;
    }
  }

}

.grid-mode{
  display: grid;
  grid-template-rows: 1fr auto;

  .first-bundle-opt, .configuration{
    display: contents;
  }
}
</style>
